<template lang="html">
    <div class="exploitation-moteur">
        <h2>{{getTextArray('motor_nav')[4][getLangage]}}</h2>
        <el-row>
            <el-form-item :label="getText('motor_form_working_duration')" prop="annual_working_time" :show-message="showMessage('annual_working_time')">
                <el-input v-model="factoryEngine.annual_working_time" required></el-input>
            </el-form-item>
            <p class="info">{{getText('motor_form_annual_working_time_tooltip_message')}}</p>
            <el-form-item :label="getText('motor_form_duplicate_motor_number')" prop="number">
                <el-input v-model="factoryEngine.number" type="number"></el-input>
            </el-form-item>


        </el-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
        };
    },
    props: {
        factoryEngine: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
            'getLangage'
        ])
    },
    methods: {
        showMessage(el) {
            if (this.factoryEngine[el].length)
                return true;
            return false;
        },
    }
};
</script>

<style lang="less">
@import '../../../less/variables';

.exploitation-moteur {
    width: 100%;
    padding: 5px 15px 40px;
    border: 5px solid #efefef !important;

    // .data-estimation {
    //     .icon-plus, .icon-minus {
    //         font-size: 25px;
    //         line-height: 25px;
    //         color: @color-1;
    //         margin-top: 25px;
    //         margin-left: 10px;
    //     }
    // }
    // .data-graph-placeholder {
    //     margin-top: 50px;
    //     background: #e1e1e1;
    //     text-align: center;
    //     min-height: 300px;
    //     padding-top: 100px;
    //     color: #666;

    //     .icon-stats {
    //         font-size: 40px;
    //     }
    // }
    .info {
        color: @color-1;
        margin: 40px 0 0 5%;
        font-size: 12px;
    }
}

// .modal-exploitation-data {
//     #graph {
//         min-width: 800px;
//         width: 90%;
//         .modebar--hover {
//             display: none;
//         }
//     }
//     .modal-exploitation-saisie {
//         width: 600px;
//         .plot-container {
//             display: none;
//         }
//     }
//     // width: 880px;
//     .icon-plus, .icon-minus {
//         display: block;
//         width: 100%;
//         text-align: center;
//         font-size: 25px;
//         line-height: 25px;
//         color: @color-1;
//         margin-top: 25px;
//         margin-left: 10px;
//     }
// }

// .dialogButton {
//     margin: 6px 8px 50px 5%;
// }
// .modal-exploitation-actions {
//     padding-right: 20px !important;
//     padding-bottom: 20px !important;
// }

// .el-radio.is-checked {
//     .el-radio__inner {
//         border-color: @color-1 !important;
//         background-color: @color-1 !important;
//     }
//     .el-radio__label {
//         color: @color-1;
//     }
// }

// .el-dialog__body {
//     text-align: center !important;
//     .el-upload__tip {
//         margin-bottom: 20px;
//     }
//     .el-upload-dragger:hover {
//         border-color: @color-1;
//     }
//     .icon {
//         margin-top: 55px;
//         .icon-minus {
//             font-size: 27px;
//             color: @color-1;
//         }
//         .icon-plus {
//             font-size: 27px;
//             color: @color-1;
//         }
//     }
//     .spaceTop {
//         margin-top: 40px;
//     }
// }


// .radio {
//     display: flex;
//     justify-content: flex-start;
//     flex-direction: row;
//     margin: 20px auto;
//     width: 90%;
//     flex-wrap: wrap;
//     align-items: center;
//     label {
//         margin-left: 0 !important;
//         margin-right: 20px;
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/partials/wizzard/DonneesForm.vue